import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInfoCode } from "src/models/General/InfoCode.models";

interface infoCodestate {
  infoCodes: IInfoCode[];
  infoCodeToEdit: IInfoCode | null;
}

const initialState: infoCodestate = {
  infoCodes: [],
  infoCodeToEdit: null,
};

const infoCodeSlice = createSlice({
  name: "InfoCode",
  initialState,
  reducers: {
    setInfoCodeList: (state, action: PayloadAction<IInfoCode[]>) => {
      state.infoCodes = action.payload;
    },
    concatListInfoCode: (
      state: infoCodestate,
      action: PayloadAction<IInfoCode[]>
    ) => {
      state.infoCodes = [...state.infoCodes.concat(action.payload)];
    },
    setInfoCodeToEdit: (state, action: PayloadAction<IInfoCode | null>) => {
      state.infoCodeToEdit = action.payload;
    },
    addInfoCode: (state, action: PayloadAction<IInfoCode>) => {
      state.infoCodes.push(action.payload);
    },
    updateInfoCode: (state, action: PayloadAction<IInfoCode>) => {
      let itemIndex = state.infoCodes.findIndex(
        item => item.infoCodeId === action.payload.infoCodeId
      );
      if (itemIndex !== -1) state.infoCodes[itemIndex] = action.payload;
    },
    deleteInfoCode: (state, action: PayloadAction<number>) => {
      const newArray = state.infoCodes.filter(
        item => item.infoCodeId !== action.payload
      );
      state.infoCodes = newArray;
    },
  },
});

export const {
  setInfoCodeList,
  concatListInfoCode,
  setInfoCodeToEdit,
  addInfoCode,
  updateInfoCode,
  deleteInfoCode,
} = infoCodeSlice.actions;

export default infoCodeSlice.reducer;
